import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { ApiErrorPageInternal, LoadingScreen } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { CarContactsOverview, useAuthContext, useIsGroupAdmin } from 'noddi-web';
import { Navigate } from 'react-router-dom';
import { useReturnToGroupPicker } from '../../../hooks/useReturnToGroupPicker';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';
import { getCommonTranslations, getTableTranslations } from '../../../utils/commonTranslations';

export const NotificationSettings = () => {
  const { currentUserGroupId: userGroupId, userData } = useAuthContext();
  const { currentBrand } = useCurrentBrand();
  const {
    isGroupAdmin,
    isLoading: isGroupAdminLoading,
    error: isGroupAdminError
  } = useIsGroupAdmin(userGroupId, userData?.user.id);

  const handleSelfRemoved = useReturnToGroupPicker();
  const selectedGroup = userData?.user.userGroups.find((userGroup) => userGroup.id === userGroupId);
  const {
    data: brand,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getByDomainBrand,
    input: { brandDomain: currentBrand }
  });

  if (isPending || isGroupAdminLoading) {
    return <LoadingScreen />;
  }
  if (error || isGroupAdminError || !brand) {
    return <ApiErrorPageInternal error={[error, isGroupAdminError]} />;
  }
  if (!isGroupAdmin) {
    return <Navigate to={customerRoutes.homepage.getPath()} replace />;
  }

  return (
    <ContentWrapperCustomerApp width='lg' hideBackButton title={t`Members and drivers`}>
      <CarContactsOverview
        userGroupId={userGroupId!}
        brandId={brand.id}
        currentUserId={userData?.user.id}
        translations={getCommonTranslations().notificationGroupOverview}
        tableTranslations={getTableTranslations()}
        showMutationToasts
        hideTitle
        viewerCanManageMembers={isGroupAdmin}
        canAssignMembershipRole={selectedGroup?.holdsExternalCars ?? false}
        onSelfRemoved={handleSelfRemoved}
      />
    </ContentWrapperCustomerApp>
  );
};
